module.exports = __webpack_public_path__ + "img/vippack_k.479a9676.png";